import { isSuperAdmin } from "@esgt/auth"
import { useCurrentUser } from "lib/providers/CurrentUser"

export function useIsSuperAdmin() {
  const { user } = useCurrentUser()
  return isSuperAdmin(user)
}
